module.exports = __webpack_public_path__ + "img/012-moderator.1ad915c0.png";